import { render, staticRenderFns } from "./PatientMenu.vue?vue&type=template&id=1859c110&scoped=true"
import script from "./PatientMenu.vue?vue&type=script&lang=ts"
export * from "./PatientMenu.vue?vue&type=script&lang=ts"
import style0 from "./PatientMenu.vue?vue&type=style&index=0&id=1859c110&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1859c110",
  null
  
)

export default component.exports